import { nanoid } from "nanoid";

// Serves as a simple event bus that can be instantiated by components that need it.
export default class EventService {

    private subscribers: Subscribers = {};

    on (event : string, callback: Function, replace?: string) {
        if (!this.subscribers[event]){
            this.subscribers[event] = [];
        }
        const newId = replace || nanoid();
        const index = this.subscribers[event].findIndex(el => el.id === replace);
        if (index >= 0) {
            this.subscribers[event][index] = {id: newId, func: callback};
        } else {
            this.subscribers[event].push({id: newId, func: callback});
        }
        return newId;
    }

    off (event: string, id: string) {
        if (!this.subscribers[event]) {
            return;
        }
        const index = this.subscribers[event].findIndex(el => el.id === id);
        if (index >= 0) {
            this.subscribers[event].splice(index, 1);
        }
    }

    dispatch (event: string, args?: any) {
        this.subscribers[event]?.forEach((callback) => callback.func(args));
    }

    reset(key?: string) {
        if (key){
            this.subscribers[key] = [];
        } else {
          this.subscribers = {};
        }
    }

}

interface Subscribers {
    [key : string] : {id : string, func : Function}[]
}

export const DefaultEventService = new EventService();

export const GlyphEventService = new EventService();
export enum GlyphEvent {
    HIGHLIGHT_ENTRIES = "HIGHLIGHT_ENTRIES",
    REMOVE_LINKS = "REMOVE_LINKS",
    TOGGLE_HIDE_GLYPHS = "HIDE",
    INTERPOLATE = "INTERPOLATE"
}

export const TaskEditorEventService = new EventService();
export const NavEventService = new EventService();
